module.exports = __webpack_public_path__ + "static/media/04.b120af9e.jpeg";